<template>
  <div v-if="comesWith.items.length > 0 || !isEmpty(partnerPromoCodes)">
    <h3 class="body-1 mb-8 block">
      {{ i18n(translations.title) }}
    </h3>

    <div class="flex flex-wrap gap-8">
      <Chip v-for="item in items" :key="item.label" :label="item.label">
        <template #prefix>
          <component :is="item.icon" aria-hidden="true" />
        </template>
      </Chip>

      <PromoCodeChips
        :partner-promo-codes
        tracking-zone="info_accessories_section"
      />
    </div>

    <RevLink
      v-if="comesWith.displayAccessoryExclusionsModal"
      class="mt-12 block text-left"
      @click="handleModalOpen"
    >
      {{ i18n(translations.modalTrigger) }}
    </RevLink>

    <ExcludedAccessoriesModal />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconChargingWire } from '@ds/icons/IconChargingWire'
import { IconComputerMouse } from '@ds/icons/IconComputerMouse'
import { IconController } from '@ds/icons/IconController'
import { IconHdmi } from '@ds/icons/IconHdmi'
import { IconHeart } from '@ds/icons/IconHeart'
import { IconKeyboard } from '@ds/icons/IconKeyboard'
import { IconListViewChecks } from '@ds/icons/IconListViewChecks'
import { IconPlug } from '@ds/icons/IconPlug'
import { IconPower } from '@ds/icons/IconPower'
import { IconPowerAdapterApple } from '@ds/icons/IconPowerAdapterApple'

import { MODAL_NAMES } from '~/scopes/product/constants'
import Chip from '~/scopes/product-core/components/presentationals/Chip/Chip.vue'
import PromoCodeChips from '~/scopes/product-core/components/presentationals/PromoCodeChips/PromoCodeChips.vue'

import translations from './Accessories.translations'
import ExcludedAccessoriesModal from './components/ExcludedAccessoriesModal/ExcludedAccessoriesModal.vue'

const ICONS: Record<string, unknown> = {
  IconChargingWire,
  IconComputerMouse,
  IconController,
  IconHdmi,
  IconHeart,
  IconKeyboard,
  IconPlug,
  IconPowerAdapterApple,
  IconPower,
  IconListViewChecks,
}

const props = defineProps<{
  comesWith: GetProductResponse['comesWith']
  partnerPromoCodes: GetProductResponse['includedServiceOffers']['partnerPromoCodes']
}>()

const i18n = useI18n()

const items = computed(() => {
  return (props.comesWith.items ?? []).map((accessory) => ({
    icon: ICONS[accessory.icon],
    label: accessory.text,
  }))
})

function handleModalOpen() {
  openModal(MODAL_NAMES.EXCLUDED_ACCESSORIES)
}
</script>
